import { Context } from "../Engine";
import { Scene } from "../Scene";
import { Camera } from "../View/Camera";
import { RenderMode } from "../Object/ObjectManager";
import { SceneRenderer } from "./SceneRenderer";

export class DefaultSceneRenderer extends SceneRenderer {

    private ctx: Context;
    public renderMode: RenderMode;
    public preRender: boolean;

    constructor() {
        super();
        this.renderMode = RenderMode.Primary;
        this.preRender = true;
    }

    public init(ctx: Context) {
        this.ctx = ctx;
    }

    public destroy(): void {
        // Nothing to destroy
    }

    public render(scene: Scene, camera: Camera, buffer: WebGLFramebuffer) {
        let ctx = this.ctx;
        let gl = this.ctx.gl;

        if (this.preRender) {
            gl.bindFramebuffer(gl.FRAMEBUFFER, buffer);

            gl.viewport(0, 0, this.ctx.viewPort.width, this.ctx.viewPort.height);
            gl.clear(gl.COLOR_BUFFER_BIT | gl.DEPTH_BUFFER_BIT);
        }
        scene.objectManager.iterate(this.renderMode, obj => obj.render(ctx, camera, { mode: this.renderMode }));
    }
}